<template>
    <div class="fixed-save-btn">
        <img
            v-if="isMobile"
            @click="close"
            class="fixed-save-btn__close"
            src="~@/assets/images/close-fixed-btn.svg"
        >
        <span class="fixed-save-btn__txt">
            Чтобы изменить данные, не забудьте их сохранить
        </span>
        <slot class="fixed-save-btn__slot"></slot>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = ['isMobile'];
export default {
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        close() {
            this.$emit('close', true);
        },
    },
};

</script>

<style scoped lang="scss">
    @import '../../../styles/rem';

    .fixed-save-btn {
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: fixed;
        width: 100%;
        height: mrem(101);
        padding: mrem(16);
        background: rgba(239, 243, 251, 0.8);
        box-shadow: mrem(0) mrem(2) mrem(4) rgba(155, 161, 166, 0.15);
        left: 0;
        bottom: mrem(10);

        @include on-desktop {
            padding: 0;
            flex-direction: row;
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(100% - 15px);
            height: rem(80);
            left: rem(0);
            bottom: rem(30);
            box-shadow: rem(0) rem(2) rem(4) rgba(155, 161, 166, 0.15);

        }

        &__close {
            position: absolute;
            right: mrem(15);
            bottom: mrem(85);
        }

        &__txt {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 600;
            font-size: mrem(12);
            line-height: mrem(16);
            margin-bottom: mrem(9);

            @include on-desktop {
                margin-bottom: 0;
                font-weight: 400;
                margin-right: rem(16);
                font-size: rem(16);
                line-height: rem(22);
                color: #000000;
            }
        }
    }

    ::v-deep .save-block__btn {
        width: mrem(235) !important;
        height: mrem(44) !important;

        @include on-desktop {
            width: rem(243) !important;
            height: rem(48) !important;
        }

    }
</style>
